var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/~/lodash/_getPrototype.js
 ** module id = 259
 ** module chunks = 0
 **/